import React, { useEffect, useMemo, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

const DEFAULT_PAYLOAD = `{
  "email": ""
}`;

export default function CreateEmailAccountModal({ show, onClose, onCreate, loading }) {
  const [payloadText, setPayloadText] = useState(DEFAULT_PAYLOAD);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;
    setPayloadText(DEFAULT_PAYLOAD);
    setError("");
  }, [show]);

  const canSubmit = useMemo(() => payloadText.trim().length > 0, [payloadText]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canSubmit || loading) return;

    setError("");
    try {
      const payload = JSON.parse(payloadText);
      await onCreate(payload);
    } catch (err) {
      setError(err?.message || "Invalid JSON payload");
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 15 }}>Create Email Account</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="small text-muted">Payload (JSON)</Form.Label>
            <Form.Control
              as="textarea"
              rows={8}
              value={payloadText}
              onChange={(e) => setPayloadText(e.target.value)}
              placeholder='{"email": "user@example.com"}'
            />
            {error && <div className="text-danger small mt-2">{error}</div>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button variant="success" size="sm" type="submit" disabled={!canSubmit || loading}>
            {loading ? <Spinner animation="border" size="sm" /> : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
